import VatSelectorConnector from './vatSelector.props';
import VatSelectorComponent from './vatSelector.component';

export default VatSelectorConnector(VatSelectorComponent);
